import React from "react";
import { 
  Button,
  Grid,
} from "@mui/material";

import ParticlesBG from "../components/ParticlesBG";
import HomepageFadeText from "../components/HomepageFadeText";

import homeBG from "../images/bg2.svg"

const HomePage = () => {



return (
  <div>
    <div className="homeContainer">
      <HomepageFadeText />

      <div style={{ padding: "200px" }} />
      
      <ParticlesBG />
    </div>

    <div className="contentDivider" style={{ backgroundColor: "rgba(235,235,235,1)" }}>

      <Grid container spacing={2}>
        <Grid item xs={8}>
        <h2 className="homeHeader3">Nanocompetencies</h2>
        <h3 className="homeHeader4">Create learning materials with the help of Artificial Intelligence. <br/>Upload your course materials to get started. <br/><br/>Visualise and edit your personalised content to maximise learning outcomes.</h3>

        </Grid>
        <Grid item xs={2}>
        <Button variant="outlined" style={{ top: "50%", margin: "20px 20px 20px 100px" }}>Get started</Button>

        </Grid>
        <Grid item xs={2}></Grid>

      </Grid>
  
    </div>

    <div className="contentDivider" style={{ backgroundColor: "rgba(255,255,255,1)" }}>
      <img alt="homeBG" id="homeBG" className="homeBG" src={homeBG} />
    </div>
    <div className="contentDivider" style={{ backgroundColor: "rgba(235,235,235,1)" }}>
      <Grid container spacing={2}>
        <Grid item xs={2}></Grid>
        <Grid item xs={2}>
        <Button variant="outlined" color="secondary" style={{ top: "50%" }}>Sign up</Button>
              </Grid>
        <Grid item xs={8}>
          <h2 className="homeHeader3">Sign up to equip yourself</h2>
          <h3 className="homeHeader4">Learn from fun and dynamic courses <br/>Upload your progress to your CV and get your dream job. <br/><br/>Collaborate with others to share knowledge. </h3>

        </Grid>
      </Grid>
    
    </div>
  </div>
  );
};

export default HomePage;